{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Pandisha",
    "navBilling": "Malipo"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Kichupo chako. <em>Dhikri</em> yako.<br />Imeinuliwa.",
    "subtitle": "Kila kipengele unachohitaji kwa siku yenye nia zaidi — kutoka nyakati za swala na tafakuri ya aya kwa AI hadi hali ya hewa na kazi za kipaumbele — katika kichupo kipya kimoja chenye utulivu na uzuri.",
    "comparison_aria": "Ulinganisho wa mipango",
    "free": {
      "tierLabel": "Wa sasa",
      "tierName": "Bila Malipo",
      "freeLabel": "Bure daima",
      "list_aria": "Vipengele vya mpango wa bila malipo"
    },
    "pro": {
      "list_aria": "Vipengele vya mpango wa Pro",
      "tierLabel": "Pandisha hadi",
      "tierName": "Pro",
      "pricePeriod": "/ mwezi",
      "priceAlt": "au $39.99 / mwaka"
    },
    "freeFeatures": {
      "clockDate": "Onyesho la saa na tarehe",
      "verseOfDay": "Aya ya Quran ya siku",
      "dailyBackground": "Picha ya mandharinyuma ya kila siku",
      "qiblaCompass": "Dira ya Kibla",
      "basicTasks": "Kazi za msingi"
    },
    "proFeatures": {
      "weatherForecast": "Utabiri wa hali ya hewa wa siku 5",
      "verseFavorites": "Hifadhi na vinjari aya pendwa",
      "notesAi": "Madokezo yenye uchanganuzi wa AI",
      "priorityTasks": "Usimamizi wa kazi za kipaumbele",
      "verseReflection": "Tafakuri ya aya kwa AI"
    },
    "plans": {
      "monthly": {
        "label": "Kila Mwezi",
        "price": "$4.99",
        "period": "/ mwezi",
        "note": "Hutozwa kila mwezi"
      },
      "yearly": {
        "label": "Kila Mwaka",
        "price": "$39.99",
        "period": "/ mwaka",
        "note": "Miezi miwili bure",
        "badge": "Okoa 33%"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Ghairi wakati wowote. Ufikiaji wako unaendelea hadi mwisho wa kipindi cha malipo bila tozo za sehemu.",
    "billingPeriod_aria": "Kipindi cha malipo",
    "cta": "Endelea kwenye malipo salama",
    "ctaLoading": "Inaelekeza kwenye malipo…",
    "promoManual": "Weka msimbo {{code}} kwenye ukurasa unaofuata ili kupata punguzo lako.",
    "signingUpAs": "Unajisajili kama {{account}}",
    "trustSignals_aria": "Ishara za uaminifu",
    "reassurance": {
      "secureCheckout": "Malipo salama kupitia Stripe",
      "cancelAnytime": "Ghairi wakati wowote, bila maswali",
      "accessUntilEnd": "Ufikiaji hadi mwisho wa kipindi"
    },
    "errors": {
      "restoreSession": "Imeshindwa kurejesha kipindi chako. Tafadhali jaribu tena kutoka kwenye kiendelezi.",
      "checkoutFailed": "Imeshindwa kuanza malipo. Tafadhali jaribu tena."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Vipengele vilivyofunguliwa",
    "unlockedFeatures": {
      "weatherForecast": "Utabiri wa hali ya hewa wa siku 5",
      "verseFavorites": "Hifadhi na vinjari aya pendwa",
      "notesAi": "Madokezo yenye uchanganuzi wa AI",
      "priorityTasks": "Usimamizi wa kazi za kipaumbele",
      "verseReflection": "Tafakuri ya aya kwa AI"
    },
    "success": {
      "title": "Karibu Pro",
      "desc": "Usajili wako uko hai. Rudi kwenye kiendelezi ili kupata vipengele vyote vya Pro vikikungoja.",
      "viewBilling": "Tazama maelezo ya malipo",
      "closeTab": "Funga kichupo hiki"
    },
    "cancel": {
      "title": "Malipo yameghairiwa",
      "desc": "Usijali — mpango wako haukubadilishwa na hujatozwa. Unaweza kupandisha wakati wowote ukiwa tayari.",
      "backToUpgrade": "Rudi kwenye kupandisha",
      "returnToExtension": "Rudi kwenye kiendelezi"
    }
  },
  "billing": {
    "title": "Malipo",
    "subtitle": "Simamia usajili wako na utazame historia ya malipo.",
    "subscription_aria": "Hali ya usajili",
    "subscriptionTitle": "Usajili",
    "loading_aria": "Inapakia maelezo ya malipo",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Bila Malipo",
    "statusLabels": {
      "active": "Hai",
      "trialing": "Jaribio la bure",
      "past_due": "Imepitwa na muda",
      "unpaid": "Haijalipwa",
      "canceled": "Imeghairiwa",
      "incomplete": "Haijakamilika",
      "none": "Hakuna usajili"
    },
    "planValues": {
      "proYearly": "Pro · Kila Mwaka",
      "proMonthly": "Pro · Kila Mwezi"
    },
    "warnings": {
      "paymentFailedTitle": "Malipo yameshindwa",
      "paymentFailedDesc": "Malipo yako ya mwisho hayakukamilika. Sasisha njia yako ya malipo kupitia Simamia Malipo ili kudumisha ufikiaji wa Pro.",
      "trialEndingTitle": "Jaribio linaisha hivi karibuni",
      "trialEndingToday": "Jaribio lako la bure linaisha leo tarehe {{date}}. Ongeza njia ya malipo ili kudumisha vipengele vyako vya Pro.",
      "trialEndingInDays_one": "Jaribio lako la bure linaisha baada ya siku {{count}} tarehe {{date}}. Ongeza njia ya malipo ili kudumisha vipengele vyako vya Pro.",
      "trialEndingInDays_other": "Jaribio lako la bure linaisha baada ya siku {{count}} tarehe {{date}}. Ongeza njia ya malipo ili kudumisha vipengele vyako vya Pro."
    },
    "cancellationScheduled": "Ughairishaji umepangwa. Unabaki na ufikiaji kamili wa Pro hadi <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "Jaribio linaisha leo",
      "trialDaysRemaining_one": "Siku {{count}} imebaki katika jaribio",
      "trialDaysRemaining_other": "Siku {{count}} zimebaki katika jaribio",
      "renews": "Inafanywa upya {{date}}",
      "accessUntil": "Ufikiaji hadi {{date}}"
    },
    "kv": {
      "status": "Hali",
      "nextRenewal": "Kufanywa upya kunakofuata",
      "trialEnds": "Jaribio linaisha",
      "trialDaysLeft_one": "Siku {{count}} imebaki",
      "trialDaysLeft_other": "Siku {{count}} zimebaki",
      "endsToday": "linaisha leo",
      "plan": "Mpango"
    },
    "upgradeNudge": {
      "title": "Fungua vipengele vya Pro",
      "desc": "Hali ya hewa, nyakati za swala, tafakuri ya aya kwa AI na zaidi — $4.99/mwezi au $39.99/mwaka.",
      "cta": "Pandisha"
    },
    "actions": {
      "manageBilling": "Simamia malipo na njia ya malipo",
      "cancelConfirmTitle": "Ghairi usajili wako?",
      "cancelConfirmDesc": "Utabaki na ufikiaji kamili wa Pro hadi mwisho wa kipindi chako cha sasa cha malipo. Hakuna marejesho ya sehemu yanayotolewa.",
      "canceling": "Inaghairi…",
      "yesCancel": "Ndiyo, ghairi",
      "keepPro": "Endelea na Pro",
      "cancelSubscription": "Ghairi usajili"
    },
    "noSubscription": "Hakuna usajili uliopatikana.",
    "paymentHistory_aria": "Historia ya malipo",
    "paymentHistoryTitle": "Historia ya malipo",
    "invoices_aria": "Ankara",
    "invoiceView": "Tazama",
    "invoiceView_aria": "Tazama ankara ya tarehe {{date}}",
    "noInvoices": "Bado hakuna ankara.",
    "dangerZone_aria": "Eneo la hatari",
    "dangerZoneTitle": "Eneo la hatari",
    "deleteAccountTitle": "Futa akaunti",
    "deleteAccountDesc": "Futa akaunti yako na data zote zinazohusiana kabisa — kazi, madokezo, vipendwa, na historia ya malipo. Kitendo hiki hakiwezi kutenduliwa.",
    "deleteAccountBtn": "Futa akaunti",
    "deleteConfirm": {
      "warning": "Hii itafanya papo hapo na kwa kudumu:",
      "list": {
        "deleteContent": "Futa kazi zako zote, madokezo, na aya pendwa",
        "cancelSubscription": "Ghairi usajili wowote hai (hakuna marejesho ya muda usiotumika)",
        "removeAccount": "Ondoa akaunti yako kutoka kwenye hifadhidata yetu",
        "signOut": "Kutoa katika vifaa vyote"
      },
      "typeToConfirm": "Andika <strong>DELETE</strong> ili kuthibitisha",
      "inputPlaceholder": "DELETE",
      "deleting": "Inafuta…",
      "confirmBtn": "Futa akaunti yangu kabisa",
      "cancelBtn": "Ghairi"
    },
    "errors": {
      "loadFailed": "Imeshindwa kupakia maelezo ya malipo.",
      "cancelFailed": "Imeshindwa kughairi usajili.",
      "deleteFailed": "Imeshindwa kufuta akaunti. Tafadhali jaribu tena au wasiliana na usaidizi.",
      "portalFailed": "Imeshindwa kufungua tovuti ya malipo."
    }
  },
  "privacy": {
    "tocLabel": "Sera ya Faragha",
    "toc_aria": "Jedwali la yaliyomo",
    "lastUpdated": "Ilisasishwa mwisho<br />22 Septemba 2026",
    "sections": {
      "overview": "Muhtasari",
      "informationWeCollect": "Taarifa Tunazokusanya",
      "connectedServices": "Huduma Zilizounganishwa (Google, Todoist, Apple)",
      "howWeUse": "Jinsi Tunavyotumia Taarifa Zako",
      "howWeShare": "Jinsi Tunavyoshiriki Taarifa Zako",
      "dataRetention": "Uhifadhi wa Data",
      "yourRights": "Haki Zako za Faragha",
      "california": "Wakazi wa California (CCPA/CPRA)",
      "cookies": "Vidakuzi na Hifadhi ya Ndani",
      "security": "Usalama wa Data",
      "changes": "Mabadiliko kwenye Sera Hii",
      "contact": "Wasiliana Nasi"
    },
    "headings": {
      "informationWeCollect": "Taarifa Tunazokusanya",
      "connectedServices": "Huduma Zilizounganishwa (Google, Todoist, Apple)",
      "howWeUse": "Jinsi Tunavyotumia Taarifa Zako",
      "howWeShare": "Jinsi Tunavyoshiriki Taarifa Zako",
      "dataRetention": "Uhifadhi wa Data",
      "yourRights": "Haki Zako za Faragha",
      "california": "Wakazi wa California (CCPA / CPRA)",
      "cookies": "Vidakuzi na Hifadhi ya Ndani",
      "security": "Usalama wa Data",
      "changes": "Mabadiliko kwenye Sera Hii",
      "contact": "Wasiliana Nasi"
    }
  },
  "deleteAccount": {
    "intro": "Kufuta akaunti yako kutaondoa kabisa:",
    "list": {
      "account": "Akaunti na wasifu wako",
      "tasks": "Kazi zote",
      "notes": "Madokezo yote",
      "verses": "Aya zilizohifadhiwa",
      "billing": "Kumbukumbu za usajili"
    },
    "irreversible": "Hatua hii haiwezi kutenduliwa.",
    "appleNotice": "Kufuta akaunti hakughairi usajili ulionunuliwa kupitia App Store. Tafadhali ughairi pia katika Mipangilio → Apple ID → Subscriptions.",
    "manageSubscription": "Simamia usajili",
    "continueBtn": "Endelea kufuta",
    "keepBtn": "Hifadhi akaunti yangu",
    "confirmTitle": "Ufute akaunti yako?",
    "confirmDesc": "Akaunti yako na data zake zote zitafutwa kabisa. Hatua hii haiwezi kutenduliwa.",
    "confirmBtn": "Futa akaunti yangu kabisa",
    "deleting": "Inafuta…",
    "error": "Hatukuweza kufuta akaunti yako. Tafadhali angalia muunganisho wako kisha ujaribu tena."
  }
}
